import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-warning-2-icon',
  templateUrl: './code-warning-2.component.html'
})
export class CodeWarning2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
